import { useEffect, useState } from 'react';

/**
 * Returns the debounced value after `delay` ms.
 */
export default function useDebounce(value, delay = 1000) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);          // cancel on next change/unmount
    }, [value, delay]);

    return debounced;
}
